module.exports = __webpack_public_path__ + "static/media/my-profile.fc848bcf.svg";